<!-- Button -->
<button [matMenuTriggerFor]="languageActions" [matTooltip]="'Language' | transloco" mat-icon-button>
  <span class="relative">
    <mat-icon [svgIcon]="'mat_solid:language'"></mat-icon>
  </span>
</button>

<mat-menu #languageActions="matMenu" [xPosition]="'before'" id="language-menu">
  <div (click)="$event.stopPropagation()" class="p-2 text-smaller">
    <span class="flex flex-col leading-none">
      <span>{{ 'Current Language' | transloco }}</span>
      <span class="mt-1.5 text-md font-medium">{{ currentLanguage.nativeLabel }}</span>
    </span>
  </div>
  <mat-divider class="my-2"></mat-divider>

  <button
    *ngFor="let lang of languages"
    (click)="switchLanguage(lang.id)"
    mat-menu-item
    [class.mat-primary]="currentLang === lang.id"
  >
    <mat-icon [svgIcon]="lang.icon"></mat-icon>
    <span>{{ lang.nativeLabel }}</span>
  </button>
</mat-menu>
